import React from "react"
import PropTypes from "prop-types"

const intervalLength = 30 * 60  // in seconds

class IntervalHeaders extends React.PureComponent {
  constructor(props) {
    super(props)
    this.setTimeRef = this.setTimeRef.bind(this)
  }

  setTimeRef(e) {
    this.cellTime = e
  }

  getCurrentTime() {  // round to half an hour
    const minutes = new Date().getMinutes()
    const format = minutes < 30 ? "H A" : "H:30 A"

    return moment().tz("America/New_York").format(format)
  }

  componentDidMount() {
    if (this.props.refToTime) this.props.refToTime(this.cellTime)
  }

  render() {
    const currentTime = this.getCurrentTime()

    return (
      <tr>
        {this.props.intervals.map(({text}, index) => {
          const className = text === currentTime ? "current" : ""
          return <th key={index} className={className} ref={text === this.props.firstEventTime ? this.setTimeRef : null}>{text}</th>
        })}
      </tr>
    )
  }
}

IntervalHeaders.propTypes = {
  intervals: PropTypes.array.isRequired,
  refToTime: PropTypes.func,
  firstEventTime: PropTypes.string
}

export default IntervalHeaders
